import _defineProperty from "/home/runner/work/experian-public-site-tng/experian-public-site-tng/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { noop, toServerDuration, SKIPPED, addDuration } from '@datadog/browser-core';
import { discardNegativeDuration } from '../discardNegativeDuration';
import { RumEventType } from '../../rawRumEvent.types';
import { trackClickActions } from './trackClickActions';
import { trackManualActions } from './trackManualActions';
export var LONG_TASK_START_TIME_CORRECTION = 1;
export function startActionCollection(lifeCycle, hooks, domMutationObservable, windowOpenObservable, configuration) {
  var _lifeCycle$subscribe = lifeCycle.subscribe(0 /* LifeCycleEventType.AUTO_ACTION_COMPLETED */, function (action) {
      lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, processAction(action));
    }),
    unsubscribeAutoAction = _lifeCycle$subscribe.unsubscribe;
  var stopClickActions = noop;
  var clickActions;
  if (configuration.trackUserInteractions) {
    clickActions = trackClickActions(lifeCycle, domMutationObservable, windowOpenObservable, configuration);
  }
  var manualActions = trackManualActions(lifeCycle, function (action) {
    lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, processAction(action));
  });
  var actionContexts = {
    findActionId: function findActionId(startTime) {
      var _a;
      var manualActionId = manualActions.findActionId(startTime);
      var clickActionId = (_a = clickActions === null || clickActions === void 0 ? void 0 : clickActions.findActionId(startTime)) !== null && _a !== void 0 ? _a : [];
      return manualActionId.concat(clickActionId);
    }
  };
  hooks.register(0 /* HookNames.Assemble */, function (_ref) {
    var startTime = _ref.startTime,
      eventType = _ref.eventType;
    if (eventType !== RumEventType.ERROR && eventType !== RumEventType.RESOURCE && eventType !== RumEventType.LONG_TASK) {
      return SKIPPED;
    }
    // Long tasks triggered by interaction handlers (pointerup, click, etc.)
    // can have a start time slightly before the interaction timestamp (long_task.start_time < action.start_time).
    // This likely happens because the interaction timestamp is recorded during the event dispatch,
    // not at the beginning of the rendering frame. I observed a difference of < 1 ms in my tests.
    // Fixes flakiness in test: "associates long tasks to interaction actions"
    var correctedStartTime = eventType === RumEventType.LONG_TASK ? addDuration(startTime, LONG_TASK_START_TIME_CORRECTION) : startTime;
    var actionId = actionContexts.findActionId(correctedStartTime);
    if (!actionId.length) {
      return SKIPPED;
    }
    return {
      type: eventType,
      action: {
        id: actionId
      }
    };
  });
  hooks.register(1 /* HookNames.AssembleTelemetry */, function (_ref2) {
    var startTime = _ref2.startTime;
    return {
      // todo: fix telemetry event type
      action: {
        id: actionContexts.findActionId(startTime)
      }
    };
  });
  return {
    addAction: manualActions.addAction,
    startAction: manualActions.startAction,
    stopAction: manualActions.stopAction,
    actionContexts: actionContexts,
    stop: function stop() {
      unsubscribeAutoAction();
      stopClickActions();
      manualActions.stop();
      clickActions === null || clickActions === void 0 ? void 0 : clickActions.stop();
    }
  };
}
function processAction(action) {
  var isAuto = isAutoAction(action);
  var loadingTime = discardNegativeDuration(toServerDuration(action.duration));
  return {
    rawRumEvent: _objectSpread({
      type: RumEventType.ACTION,
      date: action.startClocks.timeStamp,
      action: _objectSpread(_objectSpread(_objectSpread({
        id: action.id,
        target: {
          name: action.name
        },
        type: action.type
      }, loadingTime !== undefined && {
        loading_time: loadingTime
      }), action.counts && {
        error: {
          count: action.counts.errorCount
        },
        long_task: {
          count: action.counts.longTaskCount
        },
        resource: {
          count: action.counts.resourceCount
        }
      }), {}, {
        frustration: {
          type: action.frustrationTypes
        }
      })
    }, isAuto ? {
      _dd: {
        action: {
          target: action.target,
          position: action.position,
          name_source: action.nameSource
        }
      }
    } : {
      context: action.context
    }),
    duration: action.duration,
    startClocks: action.startClocks,
    domainContext: isAuto ? {
      events: action.events
    } : {
      handlingStack: action.handlingStack
    }
  };
}
function isAutoAction(action) {
  return 'events' in action;
}